import Cookies from 'js-cookie';
import { connect } from 'react-redux';

import { clubJoinGTM, clubClick } from 'redux/clubs/actions';

import Edit from './Edit';
import Join from './Join';

const JoinOrEdit = (props) => {
  const { club, customer } = props;
  if (!Cookies.get('customerToken')) {
    return <Join club={club} onClickGTM={props.clubClick} />;
  }
  if (!club || !customer || !customer.data) {
    return null;
  }
  const { isActive, clubMembershipId } = isClubMember(club, customer.data);
  if (isActive) {
    return <Edit clubMembershipId={clubMembershipId} />;
  }

  return <Join club={club} onClickGTM={props.clubClick} />;
};

const isClubMember = (club, customer) => {
  const results = {
    clubMembershipId: null,
    isActive: false
  };
  if (!customer.clubs) {
    return results;
  }
  const activeClubMembership = customer.clubs.find((c) => {
    if (
      c.clubId === club.id &&
      new Date(c.signupDate) < new Date() &&
      (!c.cancelDate || new Date(c.cancelDate) > new Date())
    ) {
      return true;
    }
    return false;
  });
  if (activeClubMembership) {
    results.clubMembershipId = activeClubMembership.clubMembershipId;
    results.isActive = true;
  }
  return results;
};

const mapStateToProps = (state) => ({
  customer: state.customer
});

export default connect(mapStateToProps, {
  clubJoinGTM,
  clubClick
})(JoinOrEdit);
